import { useCallback } from 'react'
import axios from 'axios'
import { useDispatch } from 'react-redux'
import { hideLoading, showLoading } from 'reducks/loading/operations'
import { auth } from 'firebase/index'
import { PAYOUT_ENDPOINT } from 'constants/urls'
import { push } from 'connected-react-router'

const useRequestTransfer = (amount: number, store_id: string): (() => void) => {
  const dispatch = useDispatch()
  return useCallback(async () => {
    if (!store_id) return
    dispatch(showLoading())
    // トークンを取得する
    const token = await auth.currentUser?.getIdToken()
    if (typeof !token === 'undefined') {
      dispatch(hideLoading())
      console.error('認証トークンの取得に失敗しました。')
      return
    }
    // ヘッダーの宣言
    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    }
    try {
      await axios.post(
        PAYOUT_ENDPOINT,
        { amount },
        {
          headers,
          params: {
            store_id,
          },
        }
      )
      dispatch(hideLoading())
      dispatch(push('/account/revenue/bank_transfer/complete'))
    } catch (e) {
      dispatch(hideLoading())
      if (axios.isAxiosError(e)) {
        const message = e.response?.data.message || e.response?.data.error_message || ''
        alert(`振り込み処理に失敗しました。${message !== '' && message}\n詳細はサポートまでお問い合わせください。`)
        console.error('入金リクエストに失敗', e.response)
      } else {
        console.error(e)
      }
      return
    }
  }, [amount, store_id])
}

export default useRequestTransfer
